module.exports = __webpack_public_path__ + "img/summoner.3ca5ff50.png";